<template>
  <div class="sell">
    <van-search
      v-model="value"
      show-action
      label="姓名"
      placeholder="请输入搜索关键词"
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>

    <div class="withdraw-tab">
      <van-tabs v-model="active" @change="onClick">
        <van-tab :title="parent_title">
          <div class="sell-main">
            <ul>
              <van-pull-refresh v-model="refreshing" @refresh="onLoad">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoad"
                >
                  <li v-for="(item, index) in list" :key="index">
              <span class="img">
                <van-image
                  round
                  width="2.5rem"
                  height="2.5rem"
                  :src="item.avatar"
                />
              </span>
                    <div class="sell-li-r">
                      <span class="nickname">{{ item.nickname }}</span>
                      <span class="title">{{ item.name }}</span>
                      <span class="grade">{{ item.grade.name }}</span>
                    </div>
                  </li>
                </van-list>
              </van-pull-refresh>
            </ul>
          </div>
        </van-tab>
        <van-tab :title="parent_two_title"></van-tab>


      </van-tabs>
    </div>


    <Floating toUrl="/users/index" />
    <wxNoShare />
  </div>
</template>

<script>
  import { Search, Tab, Tabs, Empty, Image as VanImage, List, PullRefresh } from 'vant'

  export default {
    components: {
      [Search.name]: Search,
      [Tabs.name]: Tabs,
      [Tab.name]: Tab,
      [Empty.name]: Empty,
      [VanImage.name]: VanImage,
      [List.name]: List,
      [PullRefresh.name]: PullRefresh,
    },
    name: 'sell',
    data () {
      return {
        value: '',
        active: 0,
        page: 1,
        list: [],
        parent_title: '团队成员',
        parent_two_title: '团队订单',
        loading: false,
        finished: false,
        refreshing: false,
      }
    },
    created () {
      //
    },
    methods: {
      onLoad () {
        this.$api.get('agency/sell', {page: this.page, type:this.active}, r => {
          this.parent_title = '团队成员（'+r.data.parent_count+'）'
          this.parent_two_title = '团队订单（'+r.data.parent_two_count+'）'
          let data = r.data.list.data
          this.list.push.apply(this.list, data)
          this.loading = false
          if (this.page >= r.data.list.last_page) {
            this.finished = true;
          }
          this.page = this.page + 1
        })
      },
      onRefresh () {
        this.page = this.page + 1
        // 清空列表数据
        this.finished = false;

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.onLoad();
      },
      onSearch() {

      },
      onClick(name, title) {
        if(name == 1){
          //this.$router.push({name: 'sellOrders'})
          window.location.href = "/agency/sellOrders"
        }
        /*
        this.list = []
        this.page = 1
        this.onLoad()
        */
      }
    }
  }
</script>

<style scoped>
  .sell{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
  }
  .sell-main{
    overflow: hidden;
    padding:10px 0;
  }
  .sell-main ul{
    padding:10px 15px;
  }
  .sell-main ul li{
    font-size: 13px;
    overflow: hidden;
    margin-bottom: 15px;
  }
  .sell-main ul li .img{
    float: left;
    width: 18%;
  }
  .sell-main ul li .sell-li-r{
    float: right;
    width: 80%;
  }
  .sell-main ul li .sell-li-r span{
    display: inline-block;
    width: 32%;
    line-height: 2.5rem;
    overflow: hidden;
    height: 2.5rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sell-main ul li .sell-li-r .grade{
    width: 30%;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/agency/sell.vue